import { AxiosResponse } from 'axios';

import { useQueryClient } from '@tanstack/react-query';

import { TypeCodeState } from '../../types';
import { axiosInstance } from '~/services/fetchServiceV2';
import { requestHelper } from '~/utils/fetchHelper';

export type TypeGetCenterCodesResponse = {
  code: string;
  message: string;
  data: { center: TypeCodeState[] };
};

/**
 * @description 클러스터 내에 있는 센터 코드 조회 api
 */
export const useGetCenterCodes = () => {
  const queryClient = useQueryClient();

  const handleSuccess = (data: TypeGetCenterCodesResponse) => {
    return data?.data?.center ?? [];
  };

  const requestGetCenterCodes = async ({
    params,
    onSuccess,
  }: {
    params: {
      cluster: string;
    };
    onSuccess?: (res: TypeCodeState[]) => void;
  }) => {
    const endPoint = '/codes/clusters';
    const query = queryClient.ensureQueryData<AxiosResponse<TypeGetCenterCodesResponse>>({
      queryKey: ['codes', 'clusters', params.cluster, 'centers'],
      queryFn: () => axiosInstance.get(`${endPoint}/${params.cluster}/centers`),
      gcTime: 0,
    });

    return requestHelper(
      () => query,
      (response) => onSuccess?.(handleSuccess(response))
    );
  };

  return requestGetCenterCodes;
};
